import type { Agent } from './agent';
import { isDark } from './utils/color';

const WHITE = '#ffffff';
const TRANSLUCENT_WHITE = 'rgba(255, 255, 255, 0.2)';
const DEFAULT_BACKGROUND = WHITE;
const DEFAULT_TEXT = '#1b1b1f';

export type CardBranding = {
    background: string;
    text: string;
    logoBackground: string;
    button: {
        background: string;
        text: string;
        border: string;
        backgroundHover: string;
        textHover: string;
        backgroundActive: string;
    };
};

export function cardBranding(agent: Agent): CardBranding {
    const background = agent.backgroundColor || DEFAULT_BACKGROUND;
    const backgroundIsDark = isDark(background);
    const text = agent.textColor || (backgroundIsDark ? WHITE : DEFAULT_TEXT);

    const button = agent.actionButtonColor;
    const buttonBackground = button?.backgroundColor || (backgroundIsDark ? TRANSLUCENT_WHITE : WHITE);
    const buttonText = button?.textColor || text;

    return {
        background,
        text,
        logoBackground: agent.logoBackgroundColor || background,
        button: {
            background: buttonBackground,
            text: buttonText,
            border: button?.borderColor || 'transparent',
            backgroundHover: button?.backgroundHoverColor || buttonBackground,
            textHover: button?.textHoverColor || buttonText,
            backgroundActive: button?.backgroundActiveColor || button?.backgroundHoverColor || buttonBackground,
        },
    };
}
